import { AccessDenied } from '@/components/ui/access-denied';
import { useAccessControl } from '@/hooks/useAccessControl';
import { PushNotificationModule } from '@/modules/support/push-notification';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/dashboard/support/push-notification')({
  component: RouteComponent,
});

function RouteComponent() {
  const { canAccessSupportDashboard } = useAccessControl();
  if (!canAccessSupportDashboard) {
    return <AccessDenied />;
  }
  return <PushNotificationModule />;
}
